import Vuex from 'vuex'
import Vue from 'vue'

export const store = new Vuex.Store({
  state: {
    mainHeight: null,
    mainWidth: null,

    headerHeight: null,
    bodyHeight: null,

    commonWidth: null,
    fixedWidth: null,

    scrollLeft: 0,
    scrollTop: 0,
    scrollWidth: 0,

    colgroup: [],
    lastColDef: {},

    sortEvents: [],
    sortStates: {}
  },
  mutations: {
    clear (state) {
      state.mainHeight = null
      state.mainWidth = null

      state.headerHeight = null
      state.bodyHeight = null

      state.commonWidth = null
      state.fixedWidth = null

      state.scrollLeft = 0
      state.scrollTop = 0
      state.scrollWidth = 0

      state.colgroup = []
      state.lastColDef = {}

      state.sortEvents = []
      state.sortStates = {}
    },
    setMainWidth (state, payload) {
      state.mainWidth = payload
    },
    setMainHeight (state, payload) {
      state.mainHeight = payload
    },

    setHeaderHeight (state, payload) {
      state.headerHeight = payload
    },

    setCommonWidth (state, payload) {
      state.commonWidth = payload
    },
    setFixedWidth (state, payload) {
      state.fixedWidth = payload
    },

    setScrollLeft (state, payload) {
      state.scrollLeft = payload
    },
    setScrollTop (state, payload) {
      state.scrollTop = payload
    },
    setScrollWidth(state, payload) {
      state.scrollWidth = payload
    },

    setWidthCol (state, {index, value}) {
      if (!state.colgroup[index]) {
        Vue.set(state.colgroup, index, value)
      } else {
        state.lastColDef = {index, width: value}
        state.colgroup[index] = value
      }
    },
    setCreateNewCol(state, {index, value}) {
      Vue.set(state.colgroup, index, value)
    },
    setChangeCol(state, {index, value}) {
      state.colgroup[index] = value
    },
    setLastColDef(state, {index, value}) {
      state.lastColDef = {
        index,
        width: value
      }
    },

    addSortEvents(state, {index, func}) {
      state.sortEvents[index] = func
    },

    changeByKeySortState(state, {key, value}) {
      if (!state.sortStates[key]) {
        Vue.set(state.sortStates, key, value)
      } else {
        state.sortStates[key] = value
      }
    }
  },
  actions: {
    setWidthCol(context, {index, value, type}) {
      if (!context.state.colgroup[index]) {
        context.commit('setCreateNewCol', {index, value})
      } else {
        const def = value - context.state.colgroup[index]
        if (type === 'common') {
          context.commit('setCommonWidth', context.state.commonWidth + def)
        } else {
          context.commit('setCommonWidth', context.state.commonWidth + def)
          context.commit('setFixedWidth', context.state.fixedWidth + def)
        }
        context.commit('setChangeCol', {index, value})
      }
      context.commit('setLastColDef', {index, value})
    },
    clickSort(context, {key, multiSort}) {
      let value = context.state.sortStates[key] + 1
      if (value === 3) {
        context.commit('changeByKeySortState', {key, value: 0})
      } else {
        if (!multiSort && context.state.sortStates[key] === 0) {
          for (let index in context.state.sortStates) {
            context.commit('changeByKeySortState', {key: index, value: 0})
          }
        }
        context.commit('changeByKeySortState', {key, value})
      }
    }
  }
})
